export const UserPortalSidebarListWrapperStyles = {
	width: '100%',
	maxWidth: '100%',
	height: '100%',
	borderRadius: 0,
	boxShadow: 'none',
};

export const UserPortalSidebarListStyles = {
	height: '100%',
	display: 'flex',
	gridTemplateColumns: 'auto',
	gridTemplateRows: 'auto 1fr auto',
	alignItems: 'center',
	padding: { xs: '0 .75rem 2.5rem', md: '2.5rem .75rem' },
	maxWidth: { xs: 'calc(100% - 1.5rem)', md: '100%' },
	flexDirection: 'column',
};

export const UserPortalSidebarListItemTopStyles = {
	flexGrow: 0,
	alignSelf: 'flex-start',
};

export const UserPortalSidebarListItemBottomStyles = {
	flexGrow: 0,
	alignSelf: 'flex-end',
};
